function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CallInterfaceFloatTemplate = require('./call-interface-float.template');
var AudioBox = require('./audio-box');
var CallInterfaceFloat = /*#__PURE__*/function () {
  function CallInterfaceFloat(app, mod) {
    var _this = this;
    _classCallCheck(this, CallInterfaceFloat);
    this.app = app;
    this.mod = mod;
    this.localStream = null;
    this.audio_boxes = {};
    this.app.connection.on('show-call-interface', function (videoEnabled, audioEnabled) {
      _this.render();
      _this.addStream('local', null);
      _this.attachEvents();
    });
    this.app.connection.on('add-local-stream-request', function (localStream) {
      _this.localStream = localStream;
      _this.addStream('local', localStream);
    });
    this.app.connection.on('add-remote-stream-request', function (peer, remoteStream) {
      _this.addStream(peer, remoteStream);
      if (remoteStream) {
        _this.startTimer();
      }
    });
    this.app.connection.on('remove-peer-box', function (peer_id) {
      var _this$audio_boxes$pee;
      if ((_this$audio_boxes$pee = _this.audio_boxes[peer_id]) !== null && _this$audio_boxes$pee !== void 0 && _this$audio_boxes$pee.audio_box) {
        if (_this.audio_boxes[peer_id].audio_box.remove) {
          _this.audio_boxes[peer_id].audio_box.remove();
          delete _this.audio_boxes[peer_id];
        }
      }
    });
    app.connection.on('stun-new-speaker', function (peer) {
      console.debug('TALK [float] New Speaker: ' + peer);
      document.querySelectorAll('.audio-box').forEach(function (item) {
        if (item.id === "audiostream".concat(peer)) {
          item.classList.add('speaker');
        } else {
          item.classList.remove('speaker');
        }
      });
    });
  }
  return _createClass(CallInterfaceFloat, [{
    key: "destroy",
    value: function destroy() {
      this.app.connection.removeAllListeners('show-call-interface');
      this.app.connection.removeAllListeners('add-local-stream-request');
      this.app.connection.removeAllListeners('add-remote-stream-request');
      this.app.connection.removeAllListeners('remove-peer-box');
      this.app.connection.removeAllListeners('stun-new-speaker');
    }
  }, {
    key: "render",
    value: function render() {
      if (!document.getElementById('small-audio-chatbox')) {
        this.app.browser.addElementToDom(CallInterfaceFloatTemplate());
      } else {
        this.app.browser.replaceElementById(CallInterfaceFloatTemplate(), 'small-audio-chatbox');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelectorAll('.disconnect-control').forEach(function (item) {
        item.onclick = function () {
          _this2.app.connection.emit('stun-disconnect');
        };
      });
      document.querySelectorAll('.audio-control').forEach(function (item) {
        item.onclick = function () {
          _this2.toggleAudio();
        };
      });
      this.app.browser.makeDraggable('small-audio-chatbox', '', true);
    }
  }, {
    key: "close",
    value: function close() {
      this.audio_boxes = {};
      if (document.getElementById('small-audio-chatbox')) {
        document.getElementById('small-audio-chatbox').remove();
      }
    }
  }, {
    key: "addStream",
    value: function addStream(peer, remoteStream) {
      this.createAudioBox(peer, remoteStream);
    }
  }, {
    key: "createAudioBox",
    value: function createAudioBox(peer, remoteStream) {
      var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.stun-identicon-list';
      if (!this.audio_boxes[peer]) {
        var audioBox = new AudioBox(this.app, this.mod, peer, container);
        this.audio_boxes[peer] = {
          audio_box: audioBox,
          remote_stream: remoteStream
        };
      }
      this.audio_boxes[peer].audio_box.render(remoteStream);
    }
  }, {
    key: "toggleAudio",
    value: function toggleAudio() {
      this.app.connection.emit('stun-toggle-audio');

      //Update UI
      try {
        document.querySelector('.audio-control').classList.toggle('disabled');
        document.querySelector('.audio-control i').classList.toggle('fa-microphone-slash');
        document.querySelector('.audio-control i').classList.toggle('fa-microphone');
      } catch (err) {
        console.error('TALK.float [toggleAudio] Error:', err);
      }
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      if (this.timer_interval) {
        clearInterval(this.timer_interval);
      }
      var timerElement = document.querySelector('.timer .counter');
      timerElement.classList.remove('paused-timer');
      var seconds = 0;
      var timer = function timer() {
        seconds++;

        // Get hours
        var hours = Math.floor(seconds / 3600);
        // Get minutes
        var minutes = Math.floor((seconds - hours * 3600) / 60);
        // Get seconds
        var secs = Math.floor(seconds % 60);
        if (hours > 0) {
          hours = "0".concat(hours, ":");
        } else {
          hours = '';
        }
        if (minutes < 10) {
          minutes = "0".concat(minutes);
        }
        if (secs < 10) {
          secs = "0".concat(secs);
        }
        timerElement.innerHTML = "".concat(hours).concat(minutes, ":").concat(secs);
      };
      this.timer_interval = setInterval(timer, 1000);
    }
  }, {
    key: "pauseTimer",
    value: function pauseTimer() {
      if (this.timer_interval) {
        clearInterval(this.timer_interval);
      }
      var timerElement = document.querySelector('.timer .counter');
      this.timer_interval = setInterval(function () {
        timerElement.classList.toggle('paused-timer');
      }, 600);
    }
  }]);
}();
module.exports = CallInterfaceFloat;